import { render, staticRenderFns } from "./HotelsAdvancedDetailRooms.vue?vue&type=template&id=97ef0f5c&"
import script from "./HotelsAdvancedDetailRooms.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports